import checkout from './checkout/en.js'
import components from './components/en.js'
import menu from './menu/en.js'
import map from './map/en.js'
import merchant from './merchant/en.js'
import merchantAccount from './merchantAccount/en.js'
import system from './system/en.js'
import customerService from './customerService/en.js'
import dashboard from './dashboard/en.js'
import data from './data/en.js'
import payment_links from './payment_links/en.js'
import merchant_auth from './merchant_auth/en.js'
import send_pagements from './send_pagements/en.js'
import developer from './developer/en.js'
import payment_page from './payment_page/en.js'
import createMchCode from './createMchCode/en.js'
import va from './va/en.js'
import tips from './tips/en.js'
import serviceProvider from './serviceProvider/en.js'
import payment_link from './payment_links/en.js'
import kyc from './kyc/en.js'
import acceptPayments from './acceptPayments/en.js'
import no_auth from './no_auth/en.js'
import operation from './operation/en.js'

export default {
  components,
  menu,
  map,
  merchant,
  merchantAccount,
  system,
  customerService,
  dashboard,
  data,
  payment_links,
  merchant_auth,
  send_pagements,
  developer,
  payment_page,
  createMchCode,
  va,
  tips,
  checkout,
  serviceProvider,
  payment_link,
  kyc,
  acceptPayments,
  no_auth,
  operation,
  mfa: {
    timeout_title: 'Security Timeout Verification',
    timeout_content: 'Enter the Google MFA Verification Code',
    title: 'Security Verification',
    code: 'MFA Code',
    placeholder: 'Please enter MFA code',
    required: 'Please enter MFA code',
    length: 'Please enter 6-digit code',
    invalid: 'Invalid MFA code',
    enter_code: 'Please enter the 6-digit MFA verification code provided for you from Google Authenticator'
  }
}

